import cn from 'clsx';
import { faFire } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Category } from './types';

type Props = {
  category: Category;
  isActive: boolean;
  className?: string;
};

/**
 * The round badge beside a category.
 *
 * Magzter gives an icon url for every category it has; the leading "Most Popular" entry
 * is ours and has none, so it draws a flame instead. headless_jshop shipped a bundled png
 * for that one — an icon in a colour we already own beats importing a raster from another
 * repo for a single circle.
 */
export default function CategoryIcon({ category, isActive, className }: Props) {
  const ringClasses = cn(
    'shrink-0 rounded-full border-2 bg-white',
    isActive ? 'border-yellow-600' : 'border-yellow-200 group-hover:border-yellow-400',
    className
  );

  if (category.icon) {
    return <img src={category.icon} alt="" width={40} height={40} className={cn(ringClasses, 'w-10 h-10')} />;
  }

  return (
    <span className={cn(ringClasses, 'w-10 h-10 inline-flex items-center justify-center')} aria-hidden="true">
      <FontAwesomeIcon icon={faFire} className={isActive ? 'text-yellow-700' : 'text-yellow-500'} />
    </span>
  );
}
